import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={17}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.514 3.128C11.292-.285 6.154-.361 2.807 2.824l-.895-.947c-.286-.304-.788-.152-.877.265L.015 6.578c-.09.398.25.778.644.683l4.189-1.08c.394-.096.537-.627.25-.93l-.984-1.043c2.631-2.426 6.623-2.35 9.13.304 2.595 2.749 2.595 7.26-.019 10.029l-.25.246c-.376.36-.394.967-.072 1.365.18.209.43.323.68.323.215 0 .43-.076.609-.247.107-.095.215-.209.304-.322 3.33-3.527 3.33-9.252.018-12.778ZM10.576 16.248l-.34.113c-.483.133-.77.664-.644 1.195.107.436.483.72.877.72a.988.988 0 0 0 .233-.038c.143-.037.286-.094.43-.132.483-.17.733-.72.572-1.214-.125-.53-.644-.815-1.128-.644ZM7.496 16.532l-.358-.057c-.501-.114-.985.227-1.074.758-.108.531.214 1.043.716 1.138.143.038.304.057.447.076.036 0 .09.019.143.019.448 0 .842-.342.895-.835.072-.53-.268-1.023-.77-1.1ZM4.346 15.09a.895.895 0 0 0-1.29.151c-.304.418-.25 1.024.144 1.366.125.094.233.19.358.284.161.114.34.17.519.17a.875.875 0 0 0 .752-.417c.286-.436.197-1.042-.215-1.346l-.268-.208ZM2.414 12.53c-.215-.492-.752-.7-1.218-.473-.465.227-.662.796-.447 1.289.071.152.125.284.197.436a.914.914 0 0 0 .805.512.912.912 0 0 0 .43-.114c.447-.246.609-.834.376-1.308l-.143-.341Z"
      fill="#636F7C"
    />
    <path d="M4.418 8.21v3.853h5.738V8.235L4.418 8.21Z" fill="#636F7C" />
    <path
      d="M12.482 12.272v-.834h.295c.318 0 .59-.288.59-.625V9.355c0-.336-.272-.624-.59-.624h-.295v-.834c0-.336-.272-.625-.59-.625H4.025c-.318 0-.492.312-.492.649v4.327c0 .337.174.648.492.648h7.867c.318 0 .59-.288.59-.624Zm-8.162 0c-.029 0-.098-.074-.098-.105V8.106c0-.03.07-.104.098-.104h7.375c.03 0 .099.073.099.104v4.061c0 .031-.07.105-.099.105H4.32Z"
      fill="#636F7C"
    />
  </svg>
)

export default SvgComponent

